<template>
  <div>
    <div class="notFound">
      <div class="notFound__body">
        <p>ページが存在しません</p>
        <Btn
          :label="'ホームに戻る'"
          :color="'red'"
          class="withdraw"
          @click.native="back"
        />
      </div>
    </div>
  </div>
</template>

<script>
import redirect from '@/mixin/redirect.mixin'
import Btn from '@/components/parts/Btn'

export default {
  name: 'NotFound',

  mixins: [redirect],

  components: {
    Btn
  },

  data () {
    return {
      //
    }
  },

  created () {
    this.$nextTick(() => {
      this.$store.commit('loadingAction', false)
    })
  },

  methods: {
    back () {
      this.goBackToEcSite()
    }
  }
}
</script>

<style lang="postcss" scoped>

  .notFound {
    position: relative;
    height: calc(100vh - 100px);
    &__body {
      padding: 75px 15px 30px;
      text-align: center;
    }

    & .withdraw {
      position: absolute;
      width: calc(100% - 30px);
      max-width: 600px;
      bottom: 40px;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/errors/404.vue